export default "__VITE_ASSET__DGaea0CU__"